import * as React from "react"
import { cn } from "../../lib/utils"
import { motion } from "framer-motion"

const ModernDashboard = React.forwardRef(({ 
  children,
  className,
  title,
  subtitle,
  actions,
  ...props 
}, ref) => {
  return (
    <div ref={ref} className={cn("p-6 space-y-6", className)} {...props}>
      {(title || actions) && (
        <div className="flex items-center justify-between">
          <div>
            {title && <h1 className="text-3xl font-bold">{title}</h1>}
            {subtitle && <p className="text-muted-foreground mt-1">{subtitle}</p>}
          </div>
          {actions && <div className="flex gap-2">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  )
})
ModernDashboard.displayName = "ModernDashboard"

const StatGrid = React.forwardRef(({ 
  children,
  className,
  ...props 
}, ref) => {
  return (
    <div 
      ref={ref}
      className={cn(
        "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
})
StatGrid.displayName = "StatGrid"

const ChartCard = React.forwardRef(({ 
  children,
  className,
  title,
  ...props 
}, ref) => {
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={cn(
        "rounded-xl border bg-card shadow-lg p-6",
        className
      )}
      {...props}
    >
      {title && (
        <h3 className="text-lg font-semibold mb-4">{title}</h3>
      )}
      {children}
    </motion.div>
  )
})
ChartCard.displayName = "ChartCard"

export { ModernDashboard, StatGrid, ChartCard }
